import React from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaGithub, FaEnvelope, FaWhatsapp } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="section contact">
      <div className="container">
        <motion.div className="section-header" initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <h2 className="section-title text-gradient">Let's Connect</h2>
          <div className="title-underline"></div>
        </motion.div>

        <motion.div 
          className="contact-card glass-panel hover-target"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="contact-grid">
            <div className="contact-info">
              <h3 className="contact-heading">Let's collaborate and innovate.</h3>
              <p className="contact-text">
                I'm currently available for freelance projects and full-time opportunities. Whether you have a visionary idea or need a lead developer to scale your product, let's talk.
              </p>
              
              <div className="contact-actions">
                <a href="mailto:prasadnallajala@gmail.com" className="btn btn-primary" aria-label="Send an Email to Prasad Nallajala">
                  <FaEnvelope aria-hidden="true" /> Send an Email
                </a>
                <a href="https://wa.me/919347190335?text=Hi%20Prasad%2C%20I%20am%20reaching%20out%20from%20your%20portfolio.%20I%27d%20like%20to%20discuss%20a%20potential%20opportunity%21" target="_blank" rel="noreferrer" className="btn btn-whatsapp" aria-label="Contact Prasad on WhatsApp">
                  <FaWhatsapp aria-hidden="true" /> WhatsApp Me
                </a>
              </div>
            </div>
            
            <div className="social-links-vertical">
              <a href="https://linkedin.com/in/prasad-nallajala" target="_blank" rel="noreferrer" className="social-pill" aria-label="Visit Prasad's LinkedIn Profile">
                <FaLinkedin size={20} aria-hidden="true" />
                <span>LinkedIn</span>
              </a>
              <a href="https://github.com/PrasadNalajala" target="_blank" rel="noreferrer" className="social-pill" aria-label="Visit Prasad's GitHub Profile">
                <FaGithub size={20} aria-hidden="true" />
                <span>GitHub</span>
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
